module.exports = __webpack_public_path__ + "3434c574fd6bb99470277a650d01a224.svg";